export default "__VITE_ASSET__BhBbQOJj__"